<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container>
    <div class="mic_container">
      <v-form ref="form" class="mic_form">
        <v-toolbar card color="#5ba322" dark class="mic_form-spacer">
          <v-toolbar-title>Übersicht über die Verlaufskontrolle</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-tabs color="#5ba322" dark slider-color="#f5a900">
          <v-tab key="0" ripple>Zielgrößen</v-tab>
          <v-tab-item key="0">
            <v-card flat>
              <v-data-table :headers="targetHeaders" :items="data" class="elevation-1">
                <v-progress-linear v-if="loading" v-slot:progress color="blue" indeterminate></v-progress-linear>
                <template v-slot:items="props">
                  <td @click="clickRow(props.item)">{{ props.item['trackingDay'] | formatDate }}</td>
                  <td
                    @click="clickRow(props.item)"
                    class="text-xs-center"
                  >{{ props.item['waistSize'] | valueUnit }}</td>
                  <td
                    @click="clickRow(props.item)"
                    class="text-xs-center"
                  >{{ props.item['weight'] | valueUnit }}</td>
                  <td
                    @click="clickRow(props.item)"
                    class="text-xs-center"
                  >{{ props.item['bloodPressure']['systolic'] | valueUnit }}</td>
                  <td
                    @click="clickRow(props.item)"
                    class="text-xs-center"
                  >{{ props.item['bloodPressure']['diastolic'] | valueUnit }}</td>
                  <td
                    @click="clickRow(props.item)"
                    class="text-xs-center"
                  >{{ props.item['physicalAbility'] }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
          <v-tab key="1" ripple>Allgemeines</v-tab>
          <v-tab-item key="1">
            <v-card flat>
              <v-data-table :headers="generalHeaders" :items="data" class="elevation-1">
                <v-progress-linear v-if="loading" v-slot:progress color="blue" indeterminate></v-progress-linear>
                <template v-slot:items="props">
                  <td @click="clickRow(props.item)">{{ props.item['trackingDay'] | formatDate }}</td>
                  <td
                    @click="clickRow(props.item)"
                    class="text-xs-center"
                  >{{ props.item['weeklyHoursMotion'] | valueUnit }}</td>
                  <td
                    @click="clickRow(props.item)"
                    class="text-xs-center"
                  >{{ props.item['amountOfFood'] }}</td>
                  <td
                    @click="clickRow(props.item)"
                    class="text-xs-center"
                  >{{ props.item['snacks'] | germanBoolean}}</td>
                  <td
                    @click="clickRow(props.item)"
                    class="text-xs-center"
                  >{{ props.item['wellBeing'] }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
          <v-tab key="2" ripple>Blutwerte</v-tab>
          <v-tab-item key="2">
            <v-card flat>
              <v-data-table :headers="bloodHeaders" :items="data" class="elevation-1">
                <v-progress-linear v-if="loading" v-slot:progress color="blue" indeterminate></v-progress-linear>
                <template v-slot:items="props">
                  <td @click="clickRow(props.item)">{{ props.item['trackingDay'] | formatDate }}</td>
                  <td
                    @click="clickRow(props.item)"
                    class="text-xs-center"
                  >{{ props.item['bloodsugar'] | valueUnit }}</td>
                  <td
                    @click="clickRow(props.item)"
                    class="text-xs-center"
                  >{{ props.item['longtermSugar'] | valueUnit }}</td>
                  <td
                    @click="clickRow(props.item)"
                    class="text-xs-center"
                  >{{ props.item['triglycerides'] | valueUnit }}</td>
                  <td
                    @click="clickRow(props.item)"
                    class="text-xs-center"
                  >{{ props.item['cholesterol'] | valueUnit }}</td>
                  <td
                    @click="clickRow(props.item)"
                    class="text-xs-center"
                  >{{ props.item['hdlCholesterol'] | valueUnit }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
<!--          <v-tab key="3" ripple>Medikamente</v-tab>-->
<!--          <v-tab-item key="3">-->
<!--            <v-card flat>-->
<!--              <v-data-table :headers="medsHeaders" :items="data" class="elevation-1">-->
<!--                <v-progress-linear v-if="loading" v-slot:progress color="blue" indeterminate></v-progress-linear>-->
<!--                <template v-slot:items="props">-->
<!--                  <td @click="clickRow(props.item)">{{ props.item['trackingDay'] | formatDate }}</td>-->
<!--                  <td @click="clickRow(props.item)" class="text-xs-left">-->
<!--                    <li v-for="med in props.item['highBloodPressureMedicine']" v-bind:key="med.id">{{ med | medicine}}</li>-->
<!--                  </td>-->
<!--                  <td @click="clickRow(props.item)" class="text-xs-left">-->
<!--                    <li v-for="med in props.item['diabetesMedicine']" v-bind:key="med.id">{{ med | medicine}}</li>-->
<!--                  </td>-->
<!--                </template>-->
<!--              </v-data-table>-->
<!--            </v-card>-->
<!--          </v-tab-item>-->
        </v-tabs>
        <div class="mic_form-content">
          <v-btn color="#f5a900" @click="input" class="white--text">Daten eingeben</v-btn>
          <v-btn color="#f5a900" @click="charts" class="white--text" :disabled="data.length == 0">Verlaufskurve anzeigen</v-btn>
        </div>
      </v-form>
    </div>
  </v-container>
</template>
<script>
import { trackingService } from '../_services'

export default {
  data () {
    return {
      data: [],
      loading: true,
      targetHeaders: [
        {
          text: 'Datum der Verlaufskontrolle',
          align: 'left',
          sortable: true,
          value: 'trackingDay'
        },
        {
          text: 'Taillenweite',
          align: 'center',
          sortable: false,
          value: 'waistSize'
        },
        { text: 'Gewicht', align: 'center', sortable: false, value: 'weight' },
        {
          text: 'Blutdruck systolisch',
          align: 'center',
          sortable: false,
          value: 'bloodPressure.systolic'
        },
        {
          text: 'Blutdruck diastolisch',
          align: 'center',
          sortable: false,
          value: 'bloodPressure.diastolic'
        },
        {
          text: 'Körperliche Leistungsfähigkeit',
          align: 'center',
          sortable: false,
          value: 'physicalAbility'
        }
      ],
      generalHeaders: [
        {
          text: 'Datum der Verlaufskontrolle',
          align: 'left',
          sortable: true,
          value: 'trackingDay'
        },
        {
          text: 'Stunden Bewegung pro Woche',
          align: 'center',
          sortable: false,
          value: 'weeklyHoursMotion'
        },
        {
          text: 'Nahrungsmenge',
          align: 'center',
          sortable: false,
          value: 'amountOfFood'
        },
        {
          text: 'Zwischensnacks',
          align: 'center',
          sortable: false,
          value: 'snacks'
        },
        {
          text: 'Wohlbefinden/Lebensqualität',
          align: 'center',
          sortable: false,
          value: 'wellBeing'
        }
      ],
      bloodHeaders: [
        {
          text: 'Datum der Verlaufskontrolle',
          align: 'left',
          sortable: true,
          value: 'trackingDay'
        },
        {
          text: 'Blutzucker nüchtern',
          align: 'center',
          sortable: false,
          value: 'bloodsugar'
        },
        {
          text: 'Langzeitzucker',
          align: 'center',
          sortable: false,
          value: 'longtermSugar'
        },
        {
          text: 'Triglyzeride',
          align: 'center',
          sortable: false,
          value: 'triglycerides'
        },
        {
          text: 'Cholesterin',
          align: 'center',
          sortable: false,
          value: 'cholesterol'
        },
        {
          text: 'HDL',
          align: 'center',
          sortable: false,
          value: 'hdlCholesterol'
        }
      ]
      // medsHeaders: [
      //   {
      //     text: 'Datum der Verlaufskontrolle',
      //     align: 'left',
      //     sortable: true,
      //     value: 'trackingDay'
      //   },
      //   {
      //     text: 'gegen Bluthochdruck',
      //     align: 'left',
      //     sortable: false,
      //     value: 'highBloodPressureMedicine'
      //   },
      //   {
      //     text: 'gegen Blutzucker',
      //     align: 'left',
      //     sortable: false,
      //     value: 'diabetesMedicine'
      //   }
      // ]
    }
  },
  created () {
    trackingService
      .getTrackingsForUser(JSON.parse(localStorage.getItem('user')).id)
      .then(
        response => {
          this.loading = false
          this.data = response.data
        },
        error => {
          this.loading = false
          console.error(error)
        }
      )
  },
  methods: {
    input () {
      trackingService
        .getProfile(JSON.parse(localStorage.getItem('user')).id)
        .then(
          response => {
            if (!response.data) {
              this.loading = false
              this.$router.push('/profile')
            } else {
              this.loading = false
              this.$router.push('/tracking')
            }
          },
          error => {
            this.loading = false
            if (error.response.status === 404) {
              this.$router.push('/profile')
            }
            console.log(error)
          }
        )
    },
    charts () {
      this.$router.push('/charts')
    },
    clickRow (item) {
      localStorage.setItem('previewTrackingDetailData', JSON.stringify(item))
      this.$router.push({ name: 'detail' })
    }
  }
}
</script>

<style scoped="true">
/*.v-text-field {*/
/*margin-top: 20px!important;*/
/*}*/
.v-input--radio-group {
  margin-top: 40px !important;
}
.mic_subheader {
  margin-top: 50px;
}
.mic_double-item-input-row {
  padding-right: 25px;
}
.mic_button_spacer {
  margin-top: 25px;
}
.v-text-field__details {
  margin-top: 40px;
}

.horizontal-scroll {
  overflow: auto;
  white-space: nowrap;
}

.text-xs-center {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/tracking/TrackingOverviewPage.vue